import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DraggableList from 'react-draggable-list'
import DraggableItem from './DraggableItem'

export default class DraggableListComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      list: props.list
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState(() => ({
        list: nextProps.list
      }))
    }
  }

  render() {
    const props = this.props
    return (
      <ul className={`draggable-list ${props.itemType}`}>
        <DraggableList
          itemKey="id"
          template={DraggableItem}
          list={this.state.list}
          onMoveEnd={(newList, movedItem, oldIndex, newIndex) =>
            this.onMoveEnd(newList, movedItem, oldIndex, newIndex)
          }
          container={() => document.body}
          draggable
          commonProps={props}
        />
      </ul>
    )
  }

  onMoveEnd(newList, movedItem, oldIndex, newIndex) {
    this.setState({ list: newList })
    if (oldIndex !== newIndex) {
      this.props.editListItemPosition(movedItem.id, newIndex)
    }
  }
}

DraggableListComponent.propTypes = {
  list: PropTypes.array.isRequired,
  deleteItem: PropTypes.func,
  handleEditClick: PropTypes.func,
  editListItemPosition: PropTypes.func.isRequired,
  itemType: PropTypes.string.isRequired,
  hideEdit: PropTypes.bool,
  hideDescription: PropTypes.bool,
  hideDelete: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/mini/DraggableListComponent.js